// extracted by mini-css-extract-plugin
export default {"root":"Home_root__sUAbM"};